export const PM_SET_SETUP_DETAILS = "PM_SET_SETUP_DETAILS";
export const PM_SET_SELECTED_CONTENT = "PM_SET_SELECTED_CONTENT";
export const ON_SELECTED_FILTERS_CHANGE = "ON_SELECTED_FILTERS_CHANGE";